import Lottie, { Options } from "react-lottie";
import * as fryingPanAnimation from "../animations/frying-pan.json";

export function FryingPanLottieLoading() {
  return (
    <LottieViewerComponent
      animationData={fryingPanAnimation}
      size={200}
      title="Got Cravings?"
      fontSize={30}
    />
  );
}

export function LottieViewerComponent({
  animationData,
  size = 400,
  title,
  fontSize,
}: {
  animationData: any;
  size?: number;
  title?: string;
  fontSize?: number;
}) {
  const defaultOptions: Options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="flex justify-center items-center flex-col">
      <span className="text-sm font-bold" style={{ fontSize }}>
        {title}
      </span>
      <Lottie options={defaultOptions} height={size} width={size} />
    </div>
  );
}

export function PlainLottie({
  animationData,
  size = 60,
}: {
  animationData: any;
  size?: number;
}) {
  const defaultOptions: Options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return <Lottie options={defaultOptions} height={size} width={size} />;
}
